// extracted by mini-css-extract-plugin
module.exports = {"noop":"ProviderInvoice_noop__HO7e9","titleContainer":"ProviderInvoice_titleContainer__2t_di","noDataWarning":"ProviderInvoice_noDataWarning__2dr1U"};